<template>
<div id="kt_aside" class="aside py-5 py-lg-11">
    <div class="hover-scroll-overlay-y w-100 ps-4 ps-lg-0 pe-4 me-1" id="kt_aside_menu_wrapper" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_header" data-kt-scroll-wrappers="#kt_aside" data-kt-scroll-offset="5px">

        <div class="menu menu-column menu-active-bg menu-hover-bg menu-title-gray-700 fs-6 fw-semibold menu-rounded w-100" id="#kt_aside_menu" data-kt-menu="true">


            <div class="menu-item">
                <router-link :to="{name: 'home'}" class="menu-link" exact-active-class="active">
                    <span class="menu-link"><span class="menu-title">{{$t('Acasa')}}</span></span>
                </router-link>
                <router-link :to="{name: 'Page', params: {slug: 'suport'} }" class="menu-link " exact-active-class="active">
                    <span class="menu-link"><span class="menu-title">{{ $t('Suport') }}</span></span>
                </router-link>
                <router-link :to="{name: 'Page', params: {slug: 'confidentialitate'}}" class="menu-link" exact-active-class="active">
                    <span class="menu-link"><span class="menu-title">{{ $t('Confidentialitate') }}</span></span>
                </router-link>
                <router-link :to="{name:'adeverinte.Init'}" class="menu-link" exact-active-class="active">
                    <span class="menu-link"><span class="menu-title">{{ $t('Adeverinte') }}</span></span>
                </router-link>
            </div>








        </div>
        <!--end::Menu-->
    </div>
    <!--end::Aside nav-->
</div>
</template>
<script>
import { useRouter } from 'vue-router';

export default {
    name: 'DSidebar',
    computed : {
        isLoggedIn : function(){ return this.$store.getters['auth/isAuthenticated'] },
        user : function(){ return this.$store.getters['auth/getFullUser'] }
    },
    data() {
        return {

          };
    },
    created() {

    },
    watch: {
        // Watch for route changes
        $route(to, from) {
            console.log("Route changed from", from.name, "to", to.name);
            this.$emit("childToParent", false);
        },
    },
    methods: {

        async logout (){

            this.$store.dispatch('auth/logout').then(response => {
                this.$store.dispatch('auth/getUser').then(response => {

                    this.$router.push({name: 'auth.SignIn'});
                });
            });

        },
    }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700');
#kt_aside {
    font-family: Poppins, Helvetica, "sans-serif";
}
.clocation {
    text-align: left;
}
#kt_aside_menu_wrapper {
    position: fixed;
    z-index: 105;
    width: 225px !important;
}
@media (max-width: 992px) {
    #kt_aside_menu_wrapper {
        display: none;
    }
}
</style>
